<section class="about-card-header">
  <h1>About Stokkup</h1>
</section>
